<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>知识库</el-breadcrumb-item>
      <el-breadcrumb-item>知识库列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="关键字" prop="query">
            <el-input
              size="small"
              v-model="filter.query"
              @keyup.enter.native="getData"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="发布日期" prop="date" v-if="publish">
            <el-date-picker
              style="width: 360px"
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="getData"
            >筛选</el-button
          >
          <el-button size="small" @click="getData('reset')">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleNew"
        v-if="canEdit"
        v-permission="Auth.repositoryNew"
        >新增知识库</el-button
      >
      <el-table
        :data="data.filter((item) => item.status == filter.status)"
        stripe
        style="width: 100%"
      >
        <el-table-column align="left" prop="title" label="标题" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.title }}
            <el-tag
              size="mini"
              class="ml-5"
              v-for="item in scope.row.tag_names"
              :key="item"
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="设备分类"
          prop="item_category.whole_name"
          width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          label="创建人"
          prop="user.name"
          width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="publish ? '发布时间' : '创建时间'"
          width="150"
        >
          <template slot-scope="scope">
            <span>
              {{
                $time(
                  publish ? scope.row.updated_at : scope.row.created_at
                ).format('YYYY-MM-DD HH:mm')
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="100">
          <template slot-scope="scope">
            <span
              :class="scope.row.status == 1 ? 'text-success' : 'text-danger'"
            >
              {{ scope.row.status == 1 ? '已发布' : '草稿' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="操作" width="160">
          <template slot-scope="scope">
            <template>
              <el-popconfirm
                v-permission="Auth.repositoryDelete"
                title="确认删除吗？"
                @confirm="handleDelete(scope.$index, scope.row.id)"
                v-if="canEdit && scope.row.status == 2"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  plain
                  size="mini"
                  class="mr-10"
                  >删除</el-button
                >
              </el-popconfirm>

              <el-popconfirm
                v-permission="Auth.repositoryStatus"
                :title="`确认${scope.row.status == 1 ? '撤回' : '发布'}吗？`"
                @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
              >
                <el-button
                  slot="reference"
                  :type="scope.row.status == 1 ? 'danger' : 'primary'"
                  plain
                  size="mini"
                  >{{ scope.row.status == 1 ? '撤回' : '发布' }}</el-button
                >
              </el-popconfirm>
              <el-button
                class="ml-10"
                type="primary"
                plain
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                v-if="canEdit && scope.row.status == 2"
                v-permission="Auth.repositoryEdit"
                >编辑</el-button
              >
              <router-link
                :to="detailLink + scope.row.id"
                v-if="
                  (hasAuth('repositoryShow') &&
                    $route.name == 'repository_manage') ||
                  (hasAuth('userRepository') &&
                    $route.name == 'user_repository')
                "
              >
                <el-button class="ml-10" type="primary" plain size="mini"
                  >详情</el-button
                >
              </router-link>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>

      <repository-former
        :model="model"
        :show.sync="visible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></repository-former>
    </div>
  </div>
</template>

<script>
import {
  repositoryList,
  updateRepositoryStatus,
  deleteRepository,
} from '@/service/getData'
import { clone } from '@/util'
import { isMobile } from '@/util/index'
import RepositoryFormer from './former'
import { NoticeCategoryMap } from '@/config/global'
import { hasAuth } from '@/permission'

export default {
  components: {
    RepositoryFormer,
  },
  data() {
    return {
      hasAuth,
      NoticeCategoryMap,
      filter: {
        page: 1,
        size: 20,
        status: this.$route.name == 'repository_manage' ? 2 : 1,
        query: '',
        date: '',
      },
      total: 0,
      model: {},
      editIndex: 0,
      isMobile,
      data: [],
      visible: false,
      publish: this.$route.name != 'repository_manage',
    }
  },
  created() {
    this.getData()
  },
  computed: {
    canEdit() {
      return this.$route.name == 'repository_manage'
    },
    detailLink() {
      let link = '/dashboard/'
      if (this.$route.name == 'repository_history') {
        link += 'repository_history/'
      } else if (this.$route.name == 'user_repository') {
        link += 'user_repositories/'
      } else {
        link += 'repositories/'
      }
      return link
    },
  },
  watch: {
    $route(to, from) {
      this.data = []
      this.filter.page = 1
      this.filter.query = ''
      this.filter.date = []
      this.filter.status = to.name == 'repository_manage' ? 2 : 1
      this.publish = this.$route.name != 'repository_manage'
      this.getData()
    },
    'filter.page': function () {
      this.getData()
    },
  },
  methods: {
    async getData(op = '') {
      if (op == 'reset') {
        this.filter.query = ''
        this.filter.date = []
      }

      if (this.filter.date && this.filter.date.length > 0) {
        this.filter.start_date = this.filter.date[0]
        this.filter.end_date = this.filter.date[1]
      } else {
        this.filter.start_date = ''
        this.filter.end_date = ''
      }
      let data = clone(this.filter)
      data.page -= 1
      let res = await repositoryList(data)
      if (res.code == 0) {
        this.data = res.data.list
        this.total = res.data.total
      }
    },
    createdCallback(data) {
      this.data.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.data, this.editIndex, data)
    },
    handleNew() {
      this.model = {
        id: 0,
        title: '',
        summary: '',
        content: '',
        item_category_id: '',
        tag_names: [],
      }
      this.visible = true
    },
    handleEdit(index, item) {
      this.editIndex = index
      this.visible = true
      this.$nextTick(() => {
        this.model = {
          id: item.id,
          title: item.title,
          summary: item.summary,
          content: item.content,
          item_category_id: item.item_category_id ? item.item_category_id : '',
          tag_names: item.tag_names,
        }
      })
    },
    async handleSwitchStatus(index, id) {
      let res = await updateRepositoryStatus(id)
      if (res.code == 0) {
        this.data[index].status = this.data[index].status == 1 ? 2 : 1
        this.$message({
          message: `操作成功`,
          type: 'success',
          center: true,
        })
      }
    },
    async handleDelete(index, id) {
      let res = await deleteRepository(id)
      if (res.code == 0) {
        this.data.splice(index, 1)
      }
    },
  },
}
</script>